export const BUTTON_LINK_DEFAULTS = Object.freeze({
  label: "View Document",
  backgroundColor: "#7d4be1",
  textColor: "#FFFFFF",
  width: 200,
  minHeight: 40,
  paddingX: 20,
  paddingY: 10,
  borderRadius: 4,
  fontFamily: "Arial, Helvetica, sans-serif",
  fontSize: 16,
  fontWeight: 700,
  alignment: "center",
  verticalAlignment: "middle",
  fullWidth: false
});

export const BUTTON_LINK_FONT_FAMILY_OPTIONS = [
  { code: "Arial, Helvetica, sans-serif", name: "Arial" },
  { code: "Helvetica, Arial, sans-serif", name: "Helvetica" },
  { code: "Verdana, Geneva, sans-serif", name: "Verdana" },
  { code: "Tahoma, Geneva, sans-serif", name: "Tahoma" },
  { code: "'Trebuchet MS', sans-serif", name: "Trebuchet MS" },
  { code: "Georgia, serif", name: "Georgia" },
  { code: "'Times New Roman', Times, serif", name: "Times New Roman" },
  { code: "'Courier New', Courier, monospace", name: "Courier New" }
];

export const BUTTON_LINK_FONT_WEIGHT_OPTIONS = [
  { code: 400, name: "Normal" },
  { code: 500, name: "Medium" },
  { code: 700, name: "Bold" }
];

export const BUTTON_LINK_ALIGNMENT_OPTIONS = [
  { code: "left", name: "Left" },
  { code: "center", name: "Center" },
  { code: "right", name: "Right" }
];

export const BUTTON_LINK_VERTICAL_ALIGNMENT_OPTIONS = [
  { code: "top", name: "Top" },
  { code: "middle", name: "Middle" },
  { code: "bottom", name: "Bottom" }
];

function escapeHtml(str) {
  return String(str ?? "").replace(/[&<>"']/g, (c) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  })[c]);
}

export function buildSampleButtonHtml(rawSettings, url = "https://example.com/document/sample") {
  const s = getButtonLinkSettings(rawSettings);
  const label = escapeHtml(s.label);
  const href = escapeHtml(url);

  const tdStyle = [
    `background-color:${s.backgroundColor}`,
    `border-radius:${s.borderRadius}px`,
    `padding:${s.paddingY}px ${s.paddingX}px`,
    `text-align:center`,
    `vertical-align:${s.verticalAlignment}`,
    `box-sizing:border-box`,
    !s.fullWidth && `min-width:${s.width}px`,
    s.fullWidth && `width:100%`
  ]
    .filter(Boolean)
    .join(";");

  const aStyle = [
    `color:${s.textColor}`,
    `font-family:${s.fontFamily}`,
    `font-size:${s.fontSize}px`,
    `font-weight:${s.fontWeight}`,
    `text-decoration:none`,
    `display:inline-block`,
    `-webkit-text-size-adjust:none`
  ].join(";");

  // Inline width beats TinyMCE content_style `table { width: 100% }` (no !important).
  // bgcolor survives when a paste target strips CSS style attributes.
  const tableStyle = ["border-collapse:collapse", "border:0", s.fullWidth ? "width:100%" : "width:auto"].join(";");
  const tableAttrs = s.fullWidth ? 'width="100%"' : `align="${s.alignment}"`;
  const bgcolor = escapeHtml(s.backgroundColor);

  return `<table role="presentation" ${tableAttrs} cellpadding="0" cellspacing="0" border="0" style="${tableStyle}"><tr><td bgcolor="${bgcolor}" height="${s.minHeight}" valign="${s.verticalAlignment}" align="center" style="${tdStyle}"><a href="${href}" style="${aStyle}">${label}</a></td></tr></table>`;
}

export function getButtonLinkSettings(stored) {
  if (!stored || typeof stored !== "object") {
    return { ...BUTTON_LINK_DEFAULTS };
  }
  const merged = { ...BUTTON_LINK_DEFAULTS };
  Object.keys(BUTTON_LINK_DEFAULTS).forEach((key) => {
    const v = stored[key];
    if (typeof BUTTON_LINK_DEFAULTS[key] === "boolean") {
      if (typeof v === "boolean") merged[key] = v;
    } else if (v !== undefined && v !== null && v !== "") {
      merged[key] = v;
    }
  });
  return merged;
}
